import React from "react";

function FieldsetError({ children }) {
  return <div className="atd-Fieldset--error">{children}</div>;
}

export default FieldsetError;
